import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { error } from "console";
import firebase from "firebase/app";
import "firebase/auth";
import { GoogleAuthService } from "src/app/core/services/google-auth.service";
import { UserService } from "src/app/core/services/user.service";
import Swal from "sweetalert2";
@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {

  isLoading: boolean = false;
  isDisabled: boolean = false;


  forgotPasswordForm: FormGroup;
  

  userEmail: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    private googleService: GoogleAuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(".*\\.com$")]],
    });
  }

  onNavigateLogin() {
    this.router.navigate(["login"]);
  }

  resetPassword() {
    this.isLoading = true;
    this.isDisabled = true;

    const userEmail = {
      email: this.forgotPasswordForm.controls.email.value,
    };

    if (this.forgotPasswordForm.valid) {
      this.googleService
        .ForgotPassword(userEmail.email)
        
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Password reset email has been sent.",
            text: "Please check your email and click on the link sent to reset password.",
            showConfirmButton: false,
            showCloseButton: true
          }).then(() => {
            this.isLoading = false;
            this.isDisabled = false;

          });
          

        })
        .catch((error) => {

          const errorCode = error.code;

          this.isLoading = true;
          this.isDisabled = true;

          switch (errorCode) {
            case "auth/user-not-found":
              Swal.fire({
                position: "center",
                icon: "error",
                title: "User not found",
                showConfirmButton: false,
                showCloseButton: true
              });

              this.isLoading = false;
              this.isDisabled = false;

              break;
            case "auth/too-many-requests":
              this.isLoading = true;

              Swal.fire({
                position: "center",
                icon: "error",
                title: "Too many requests",
                showConfirmButton: false,
                showCloseButton: true
              });

              this.isLoading = false;
              this.isDisabled = true;

              break;
          }
        });
    } else {

      const userEmail = this.forgotPasswordForm.get("newPassword"); 

      if(userEmail == null){

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please input a valid email",
          showCloseButton: true
        });

      }else{

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please fill all required fields",
          showCloseButton: true
        });

      }

  
      this.forgotPasswordForm.markAllAsTouched();
      this.isLoading = false;
      this.isDisabled = false;

    }
  }
}
